import { API_TYPE } from 'utils';

export const LOGIN = API_TYPE('LOGIN');
export const REGISTER = API_TYPE('REGISTER');
export const RESET_PASSWORD = API_TYPE('RESET_PASSWORD');
export const FORGOT_PASSWORD = API_TYPE('FORGOT_PASSWORD');
export const LOGOUT = 'LOGOUT';
